import { Component, OnInit, Input } from '@angular/core';
import { saveAs } from 'file-saver';
import { CountyRecord } from 'src/app/models/countyRecord';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.css']
})
export class ExportComponent implements OnInit {
  @Input() data: CountyRecord[];
  @Input() fileName: string = 'data';
  @Input() disabled: boolean;
  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';

  constructor() { }

  ngOnInit() {
  }

  onClick() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.formatData());
    const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, this.fileName);
  }

  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {type: this.fileType});
    saveAs(data, fileName + this.fileExtension);
  }

  formatData() {
    const data: any[] = [];

    this.data.forEach(n => {
      const d = {
        Instrument: n.RecordNumber,
        Date: n.RecordDate,
        Status: n.Status,
        Score: n.Score,
        From: n.FromParties.join(', '),
        To: n.ToParties.join(', '),
        Updated: n.updatedAt
      };

      data.push(d);

    });

    return data;
  }
}
